import * as React from 'react'
import { useTranslation } from 'react-i18next'


import Auth from 'components/Auth'

import Alert from 'components/Alert'
import Field from 'components/Form/Field'
import Label from 'components/Form/Label'
import Input from 'components/Form/Input'
import Button from 'components/Button'

// routing stuff
import { Redirect } from 'react-router-dom'

// reducer
import { useDispatch, useSelector } from 'react-redux'
import { signInPinCode } from 'store/reducers/auth.thunks'

import './styles.sass'
import UserStore from 'services/userLocalStorage'
import { Row } from 'components/Layout'
import { BackArrow } from 'components/Icons'
import { Creators as authCreators } from 'store/reducers/auth.reducer'
import { useQuery } from 'hooks/useQuery'

function LoginPinCode() {
  const { t } = useTranslation()
  const query = useQuery();
  const isSmsLogin = query.get("loginType") === "SMS";

  const [pincode, setPincode] = React.useState(null)
  const [error, setError] = React.useState(true)

  const reduxDispatch = useDispatch()
  const { auth } = useSelector(state => state)
  const [loading, setLoading] = React.useState(false)

  function submitForm() {
    if (!pincode || notOnlyNumbers(pincode)) {
      setError(true)
      return
    }
    setError(false)
    reduxDispatch(signInPinCode(pincode, setLoading))
  }

  function notOnlyNumbers(pin) {
    var numberPattern = /^\d+$/g;
    return !pin.trim().match(numberPattern)
  }

  function onChange({ target }) {
    setPincode(target.value)
    setError(notOnlyNumbers(target.value));
  }


  if (!auth.signinToken || auth.isAuthenticated) {
    return <Redirect to="/signin" />
  }

  const handleGoBack = () => {
    reduxDispatch(reduxDispatch(authCreators.logout()))
  }

  return (
    <section>
      <Auth>
        <Field>
          <Row position={['y-center', 'x-start']}>
            <button className="pvt-backbutton custom" onClick={handleGoBack}>
              <BackArrow />
              <span>{t('button.label.back')}</span>
            </button>
          </Row>
        </Field>
        <header className="pvt-content-header custom">
          <h2 className="pvt-content-title custom">
            {isSmsLogin ? t('loginPinCode.title.sms') : t('loginPinCode.title')}
          </h2>
        </header>
        <Field>
          <Alert
            align="start"
            size="full"
            text={
              <>
                <b>
                  {
                    isSmsLogin
                      ? t('loginPinCode.alert.sendPinCode.sms', { phone: UserStore.getPhoneHatchedData() })
                      : t('loginPinCode.alert.sendPinCode', { email: UserStore.getEmailHatchedData() })
                  }
                </b>
              </>
            }
          />
        </Field>
        {auth.error ?
          <div className="alert alert-danger" role="alert">
            <b>{t('loginPinCode.alert.invalidCode')}</b>
          </div>
          : null
        }
        <Field>
          <Label label={t('loginPinCode.label.code')} relation="password-field" />
          <Input id="password-field" onChange={onChange} type="integer"
            invalidMessage={error && pincode ? t('loginPinCode.validation.error.pincode') : null} />
        </Field>

        <Field>
          <Button onClick={submitForm} type="confirm" label={t('button.label.send')} classie="full" disabled={error} loading={loading} />
        </Field>
      </Auth>
    </section>
  )
}

export default LoginPinCode
